import { keys, values, orderBy, groupBy } from 'lodash';

export function selectedClassId(state) {
  return state.selectedClassId;
}

export function selectedClassName(state, getter) {
  if (state.managingClasses[getter.selectedClassId]) {
    return state.managingClasses[getter.selectedClassId].name;
  }

  return '모든 클래스';
}

export function managingClasses(state) {
  return state.managingClasses;
}

export function managingClassList(state) {
  return orderBy(values(state.managingClasses), ['school_year', 'year', 'name'], ['desc', 'desc', 'asc']);
}

export function managingClassIds(state) {
  return keys(state.managingClasses);
}

export function managingClassListBySchools(state, getter) {
  return groupBy(getter.managingClassList, cls => (`${cls.school_id};${cls.school_name}`));
}

export function isClassStudent(state) {
  return state.isClassStudent;
}



// WEBPACK FOOTER //
// ./src/app/classes/store/getters.js